import { render } from "./AddTransaction.vue?vue&type=template&id=2c2b697f&scoped=true"
import script from "./AddTransaction.vue?vue&type=script&lang=js"
export * from "./AddTransaction.vue?vue&type=script&lang=js"

import "./AddTransaction.vue?vue&type=style&index=0&id=2c2b697f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2b697f"]])

export default __exports__